/**
 * 跨标签页登录状态同步工具
 * 确保同一浏览器下只能登录一个账号
 * 当其他标签页登录了不同账号时，当前标签页会自动刷新
 */
import router from "@/router/route";
const CURRENT_USER_ID_KEY = "currentUserId";
let isHandlingUserSwitch = false;

/**
 * 获取当前用户的唯一标识
 * 只使用 userInfo 中的用户 ID，不依赖 token（因为 token 会刷新）
 */
export function getCurrentUserIdentifier(): string | null {
  const userInfoStr = localStorage.getItem("userInfo");
  if (!userInfoStr) {
    return null;
  }

  try {
    const userInfo = JSON.parse(userInfoStr);
    if (userInfo?.id) {
      return `user_${userInfo.id}`;
    }
    return null;
  } catch (e) {
    console.error("Failed to parse userInfo", e);
    return null;
  }
}

/**
 * 更新当前用户标识
 */
export function updateCurrentUserIdentifier(): void {
  const identifier = getCurrentUserIdentifier();
  if (identifier) {
    localStorage.setItem(CURRENT_USER_ID_KEY, identifier);
  } else {
    localStorage.removeItem(CURRENT_USER_ID_KEY);
  }
}

/**
 * 处理用户切换
 * 当检测到不同用户登录时，跳转到对应登录类型的首页
 */
export function handleUserSwitch(): void {
  // 防止重复执行
  if (isHandlingUserSwitch) {
    return;
  }

  const currentPath = router.currentRoute.value.path;

  if (currentPath === "/login" || currentPath.startsWith("/login")) {
    return;
  }

  isHandlingUserSwitch = true;

  const newLoginType = localStorage.getItem("loginType");
  let targetPath = "/";

  // 根据登录类型确定目标路径
  //   if (newLoginType === "student") {
  //     targetPath = "/student-work";
  //   } else if (newLoginType === "institutions") {
  //     targetPath = "/institutions";
  //   } else {
  //     // teacher 或其他类型
  //     targetPath = "/talk";
  //   }

  // 使用 window.location.href 确保完全重新加载
  window.location.href = targetPath;
}

/**
 * 检查 currentUserId 变化是否代表不同用户
 */
function isDifferentUserByCurrentUserId(newValue: string | null, oldValue: string | null): boolean {
  if (!newValue) {
    return false;
  }
  if (!oldValue) {
    return false;
  }
  return newValue !== oldValue;
}

/**
 * 初始化跨标签页同步监听
 */
export function initCrossTabSync(): void {
  updateCurrentUserIdentifier();
  window.addEventListener("storage", (e: StorageEvent) => {
    if (e.storageArea !== localStorage) {
      return;
    }
    if (e.key === CURRENT_USER_ID_KEY) {
      setTimeout(() => {
        if (isDifferentUserByCurrentUserId(e.newValue, e.oldValue)) {
          handleUserSwitch();
        }
      }, 100);
    }
  });

  // 监听同标签页内的 localStorage 变化
  const originalSetItem = Storage.prototype.setItem;
  let isUpdatingIdentifier = false;
  Storage.prototype.setItem = function (key: string, value: string) {
    const oldValue = this.getItem(key);
    originalSetItem.call(this, key, value);
    if (key === CURRENT_USER_ID_KEY && !isUpdatingIdentifier) {
      setTimeout(() => {
        if (isDifferentUserByCurrentUserId(value, oldValue)) {
          handleUserSwitch();
        }
      }, 0);
    }
  };

  (window as any).__originalSetItem = originalSetItem;
}

/**
 * 清理跨标签页同步
 */
export function cleanupCrossTabSync(): void {
  // if ((window as any).__originalSetItem) {
  //   Storage.prototype.setItem = (window as any).__originalSetItem;
  //   delete (window as any).__originalSetItem;
  // }
}
